import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Telegram_bot } from "../bot_toot/telegram_bot.js";
import {
    collection,
    query,
    where,
    getDocs,
    onSnapshot,
    orderBy,
    limit,
    getCountFromServer
} from "firebase/firestore";
import Loading from "../components_root/loading.jsx";
import { dbstatus } from "../firebase.js";
import { GoDownload, GoHeart } from "react-icons/go";
import Loadingimg from "../components_root/loadingimg.jsx";
import { LuFilter } from "react-icons/lu";
import CopyUID from "../components_root/copyuid.jsx";
import { Toast } from "../components_root/ToastContext.jsx";
import ShareButton from "../components_root/ShareButton.jsx";
import html2canvas from "html2canvas";
import { CiFilter } from "react-icons/ci";
import { Randomnumber } from "../components_root/rendom_number.js";
import Download_popup from "./download_popup.jsx";
import { Update_status_message_qry } from "./update_status_message.js";
import whatsapp from "../assets/icon/whatsapp-icon.png";
import instagram from "../assets/icon/instagram-logo-DjehPe9u.svg";
import youtube from "../assets/icon/youtube-logo-AGOPFgFh.svg";
import { Randomcode } from "../components_root/rendom_code.js";

export default function Profile_status({ data }) {

    const navigate = useNavigate();
    const location = useLocation();
    const { Toastshow } = Toast();
    const [downpopup, setdownpopup] = useState(false);
    const [statusdata, setstatusdata] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusmood, setstatusmood] = useState("Recommended")
    const [moodtab, setmoodtab] = useState("home");
    const [downloadingId, setDownloadingId] = useState(null);
    const [recentloading, setrecentloading] = useState(true);
    // pagination 
    const [languagemood, setlanguagemood] = useState("Recommended");
    const [recentstatusdata, setrecentstatusdata] = useState([]);
    const [statuslibrary, setstatuslibrary] = useState(0);
    const [languagedata, setlanguagedata] = useState([]);
    const [fillter, setfillter] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    const moodEmoji = {
        happy: "😊",
        shayari: "🪶",
        sad: "😢",
        love: "❤️",
        angry: "😡",
        funny: "😂",
        motivated: "🔥",
        thinking: "🤔",
        business: "💼",
        golden_Rule: "🌟",
        money: "💰"
    };

    const get_recent_status_message = () => {
        let q = null;
        q = query(
            collection(dbstatus, "statusmessage"),
            where("status", "==", true),
            where("guid", "==", data.guid),
            orderBy("date_time", "desc"),
            limit(20)
        );


        const unsubscribe = onSnapshot(q, async (snapshot) => {

            const results = await Promise.all(
                snapshot.docs.map(async (doc) => {

                    const statusData = doc.data();

                    const accQuery = query(
                        collection(dbstatus, "accounts"),
                        where("guid", "==", statusData.guid)
                    );

                    const accSnap = await getDocs(accQuery);

                    let accountInfo = null;

                    accSnap.forEach((acc) => {
                        accountInfo = acc.data();
                    });

                    return {
                        id: doc.id,
                        ...statusData,
                        accountInfo
                    };

                })
            );

            setrecentstatusdata(results);
            setrecentloading(false);
        });

        return unsubscribe;
    };



    // url params
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setmoodtab(params.get("m") || "home");
    }, [location.search]);

    function timeAgo(date) {

        const seconds = Math.floor((Date.now() - new Date(date)) / 1000);

        if (seconds < 60) return seconds + " sec ago";

        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) return minutes + " min ago";

        const hours = Math.floor(minutes / 60);
        if (hours < 24) return hours + " h ago";

        const days = Math.floor(hours / 24);
        if (days < 30) return days + " d ago";

        const months = Math.floor(days / 30);
        if (months < 12) return months + " m ago";

        const years = Math.floor(months / 12);
        return years + " y ago";
    }
    const get_status_library = async () => {
        const q = query(collection(dbstatus, "statusmessage"), where("guid", "==", data.guid));

        const snapshot = await getCountFromServer(q);
        setstatuslibrary(snapshot.data().count);

    }
    const [accountsdata, setaccountsdata] = useState([]);

    const get_accounts = async () => {
        const accQuery = query(
            collection(dbstatus, "accounts"),
            where("guid", "==", data.guid)
        );

        const accSnap = await getDocs(accQuery);

        const accountsArray = accSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));

        setaccountsdata(accountsArray);
    };


    const get_status_message = () => {

        if (!data || typeof data.guid === "undefined") {
            return () => { }; // ✅ always return function (important)
        }
        let conditions = [
            where("status", "==", true)
        ];

        if (languagemood !== "Recommended") {
            conditions.push(where("language", "==", languagemood));

        }
        if (statusmood !== "Recommended") {
            conditions.push(where("statusmood", "==", statusmood));
        }
        if (statusmood === "Recommended") {
            conditions.push(limit(80));
        }
        if (fillter == true) {
            conditions.push(orderBy("read", "desc"));
        } else {
            conditions.push(orderBy("date_time", "desc"));

        }
        const q = query(
            collection(dbstatus, "statusmessage"),
            ...conditions
        );
        setlanguagedata([]);
        const unsubscribe = onSnapshot(q, async (snapshot) => {

            const languages = new Set();

            const results = await Promise.all(
                snapshot.docs.map(async (doc) => {

                    const statusData = doc.data();

                    // collect unique languages

                    if (statusData.language) {
                        languages.add(statusData.language);
                    }


                    const accQuery = query(
                        collection(dbstatus, "accounts"),
                        where("guid", "==", statusData.guid)
                    );

                    const accSnap = await getDocs(accQuery);

                    let accountInfo = null;

                    accSnap.forEach((acc) => {
                        accountInfo = acc.data();
                    });

                    return {
                        id: doc.id,
                        ...statusData,
                        accountInfo
                    };

                })
            );

            // save unique languages
            setlanguagedata([...languages]);

            setstatusdata(results);
            setLoading(false);
        });

        return unsubscribe;
    };


    // ✅ REALTIME LISTENERS
    useEffect(() => {
        if (accountsdata.length === 0) return;
        if (!data || !data.guid) return;

        const unsub1 = get_recent_status_message();
        const unsub2 = get_status_message();

        return () => {
            unsub1 && unsub1();
            unsub2 && unsub2();
        };
    }, [accountsdata, data?.guid, statusmood, languagemood, fillter]);
    // pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = statusdata.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(statusdata.length / itemsPerPage);
    // ✅ INIT LOAD
    useEffect(() => {
        get_accounts();
        get_status_library();
    }, []);
    return (
        <>


            <div className="container_roots">
                <div className="post-container">
                    <div className="post_updates">

                        <div className="">
                            <table>
                                <tr>
                                    <td>   <div className="text-h1 bold fcap m-2">Status mood</div></td>

                                </tr>
                            </table>

                        </div>

                        <div className="ui-grid-150 m-top">
                            <div className={`ui-items p-11 rounded-30 cursor ${statusmood === "Recommended" ? "items-back-fill bold  b-1" : "hover"}`} onClick={() => {
                                setstatusmood("Recommended");
                                setlanguagemood("Recommended");

                            }} >
                                <span>✨</span>
                                <span className="fcap">Recommended</span>
                            </div>

                            {Object.entries(moodEmoji).map(([mood, emoji]) => (
                                <div
                                    key={mood}
                                    className={`ui-items cursor rounded-30 p-11 ${statusmood === mood ? "items-back-fill b-1  bold" : "hover"}`}
                                    onClick={() => {
                                        setstatusmood(mood);
                                        setlanguagemood("Recommended");

                                    }}
                                >
                                    <span>{emoji}</span>
                                    <span className="fcap">{mood.replaceAll("_", " ")}</span>
                                </div>
                            ))}
                        </div>
                        <br />
                        <div className="">
                            <div className="text-h1 bold fcap m-2">Language mood</div>
                        </div>

                        <div className="ui-grid-150 ">
                            <div className={`ui-items  rounded-30 cursor p-11 ${languagemood === "Recommended" ? "items-back-fill b-1 rounded-30 bold" : "hover"}`} onClick={() => {
                                setlanguagemood("Recommended");
                                get_status_message();
                            }} >
                                <span>🌐</span>
                                <span className="fcap">All Language</span>
                            </div>
                            {languagedata.map((language) => (
                                <div
                                    key={language}
                                    className={`ui-items cursor  rounded-30 p-11 ${languagemood === language ? "items-back-fill b-1 rounded-30 bold" : "hover"}`}
                                    onClick={() => { setlanguagemood(language); get_status_message(); }}
                                >
                                    <span className="fcap">{language}</span>
                                </div>
                            ))}

                        </div>

                    </div>
                    <div className="post_div">

                        <div className="items-back-fill p-1 rounded">
                            <table>
                                <tbody>
                                    <tr>
                                        <td width={30}>
                                            <img
                                                className="icon-photo rounded-30"
                                                src={accountsdata[0]?.photoURL || "/default-user.png"}
                                                alt="user"
                                            />
                                        </td>

                                        <td className="p-11">
                                            <div className="text-h1 bold">{accountsdata[0]?.name}</div>
                                            <div className="text-h2 text-off">
                                              
                                                <div className="text-heror-sub bold">{accountsdata[0]?.country || ""}</div>
                                            </div>
                                        </td>

                                        <td className="text-r text-h3">
                                            Reg.:
                                            {accountsdata[0]?.date_time?.toDate().toLocaleString() || ""}
                                                     <div className="text-h2 text-off">
                                              Post {statuslibrary}
                                              </div>
                                        </td>

                                        <td width={30} className="cursor">
                                            <ShareButton url={accountsdata[0]?.username} />
                                        </td>

                                    </tr>
                                </tbody>
                            </table>

                        </div>
                                 <table className="m-top">
                            <tr>
                                <td>
                                    <div className="text-h2 fcap bold">{statusmood.replaceAll("_", " ")} {currentItems.length} results</div>
                                </td>
                                <td>
                                    <div className="text-h2 text-r">
                                        {fillter === true ? "Showing views results" : `Showing latest`}
                                    </div>

                                </td>
                                <td width={30}>
                                    <div className={`cursor ${fillter === true ? "button-ui2" : "button-ui"}`} onClick={() => {
                                        setfillter(!fillter);
                                    }} >

                                        <LuFilter className="icon" />
                                    </div>
                                </td>
                            </tr>
                        </table>
                        <div className="ui-grid m-top">

                            {loading ? (
                                <>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                    <div className="ui-items  hover items-back rounded">
                                        <Loading />
                                    </div>
                                </>


                            ) : currentItems.length > 0 ? (

                                currentItems.map((row) => (

                                    <div key={row.id} className="ui-items  hover items-back rounded b-1">

                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td   width={30}>
                                                        <img
                                                            className="icon-photo-30 cursor"
                                                            src={row.accountInfo?.photoURL || "/default-user.png"}
                                                            alt="user"
                                                        />
                                                    </td>

                                                    <td  >
                                                        <div className="text-h2 bold cursor">{row.accountInfo?.name}</div>
                                                        <div className="text-h4 cursor text-off">
                                                            {row.date_time ? new Date(row.date_time).toLocaleString() : ""}
                                                        </div>
                                                    </td>

                                                    <td width={85} className="text-r text-h2">
                                                        {row.date_time ? timeAgo(row.date_time) : ""}
                                                    </td>

                                                    <td width={30} className="cursor">
                                                        <ShareButton url={`${row.contentid} ${" "} ${row.message}`} />
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>

                                        <div
                                            className=" text-h2 status_view_size"
                                        // style={{
                                        //     backgroundColor: row.statuscolor
                                        // }}
                                        >

                                            <div
                                             onClick={()=>navigate("/"+row.contentid)}
                                                className="bold text-h1 m-top line-height-25"
                                                dangerouslySetInnerHTML={{ __html: row.message }}
                                            />
                                            <div className="m-top">
                                                <table  >
                                                    <tbody>
                                                        <tr>
                                                            <td  >
                                                                <div className="text-h2 text-l bold fcap" style={{ color: row.statuscolor }}>
                                                                    {row.statusmoodEmoji} {row.statusmood}
                                                                </div>
                                                            </td>
                                                            <td className="text-h2 fcap text-r bold">
                                                                #{row.accountInfo?.username}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="text-h2 ">
                                                    https://status.aooz.in/{row.accountInfo?.username}   </div>
                                            </div>
                                        </div>

                                        <div className="p-0 ">
                                            <table className="table-fixed">
                                                <tbody>
                                                    <tr>

                                                        <td>
                                                            <div className="text-h3">
                                                                <b>{row.read + row.copy + row.like || 0}</b> Read
                                                            </div>
                                                        </td>

                                                        <td>
                                                              <div onClick={()=>navigate("/"+data.contentid)} className="text-h3 cursor">
                                                                <b>{row.comment || 0}</b> Comt
                                                            </div>  
                                                        </td>

                                                        <td>
                                                            {/* <IoColorPaletteOutline className="icon" /> */}
                                                        </td>

                                                        <td>
                                                            <CopyUID
                                                                id={
                                                                    row.message +
                                                                    "\n" +
                                                                    row.statusmoodEmoji + " #" + row.statusmood + " #aoozstatus #" + row.accountInfo?.username +
                                                                    "\nhttps://status.aooz.in/" + row.accountInfo?.username
                                                                }
                                                                contentid={row.contentid}
                                                            />
                                                        </td>

                                                        <td>

                                                            <GoDownload
                                                                onClick={() => {
                                                                    setDownloadingId(row);
                                                                    setdownpopup(true)
                                                                }
                                                                }
                                                                className="icon cursor"
                                                            />
                                                            {/* {
                                                                downloadingId === row.contentid
                                                                    ? <MdDownloadDone className="icon green" />
                                                                    : <GoDownload
                                                                        onClick={() =>
                                                                            downloadDivAsImage(
                                                                                row.contentid,
                                                                                "Aooz.in_" + row.statusmood + "_" + row.contentid
                                                                            )
                                                                        }
                                                                        className="icon cursor"
                                                                    />
                                                            } */}
                                                        </td>

                                                        <td>
                                                            <GoHeart onClick={() => Update_status_message_qry(row.contentid, "like")} className="icon cursor" />
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>

                                ))

                            ) : (
                                <p>No status found</p>
                            )}

                        </div>
                    </div>

                    <div className="post_updates ">

                        <table>
                            <tr>
                                <td>
                                    <div className="text-h2 text-l fcap "> Recent status, update:
                                        {recentstatusdata[0]?.date_time ? timeAgo(recentstatusdata[0]?.date_time) : ""}</div>
                                </td>

                                <td width={130}>
                                    <table>
                                        <tr>

                                            <td width={100}>
                                                <table>
                                                    <tr>
                                                        <td><a href="https://whatsapp.com/channel/0029Vb8FTGGEQIaimh9UtB3o" target="_blank" rel="noopener noreferrer">
                                                            <img width="20" height="20" src={whatsapp} viewBox="0 0 24 24" fill="black">
                                                            </img>
                                                        </a></td>
                                                        <td><a href="https://instagram.com/aoozstatus" target="_blank">
                                                            <img width="20" height="20" src={instagram} viewBox="0 0 24 24" fill="black">
                                                            </img>
                                                        </a></td>
                                                        <td><a href="https://www.youtube.com/@aoozstatus" target="_blank">
                                                            <img width="20" height="20" src={youtube} viewBox="0 0 24 24" fill="black">
                                                            </img>
                                                        </a></td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>

                        <div className="ui-grid ">

                            {recentloading ? (
                                <Loading />
                            ) : recentstatusdata.length > 0 ? (

                                recentstatusdata.map((row) => (

                                    <div key={row.id} className="ui-items  hover items-back p-11 rounded ">

                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={30}>
                                                        <img
                                                            className="icon-photo-30"
                                                            src={row.accountInfo?.photoURL || "/default-user.png"}
                                                            alt="user"
                                                        />
                                                    </td>

                                                    <td>
                                                        <div className="text-h2 bold">{row.accountInfo?.name}</div>
                                                        <div className="text-h4 text-off">
                                                            {row.date_time ? new Date(row.date_time).toLocaleString() : ""}
                                                        </div>
                                                    </td>

                                                    <td width={85} className="text-r text-h2">
                                                        {row.date_time ? timeAgo(row.date_time) : ""}
                                                    </td>

                                                    <td width={30} className="cursor">
                                                        <ShareButton url={`${row.contentid} ${" "} ${row.message}`} />
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>

                                        <div
                                            className="rounded text-h1 recent_status_view_size"
                                        // style={{
                                        //     backgroundColor: row.statuscolor
                                        // }}
                                        >

                                            <div  onClick={()=>navigate("/"+row.contentid)}
                                                className=" bold m-top"
                                                dangerouslySetInnerHTML={{ __html: row.message }}
                                            />
                                            <div className="m-top">
                                                <table  >
                                                    <tbody>
                                                        <tr>
                                                            <td  >
                                                                <div className="text-h2 bold text-l fcap" style={{ color: row.statuscolor }}>
                                                                    {row.statusmoodEmoji} {row.statusmood}
                                                                </div>
                                                            </td>
                                                            <td className="text-h1 text-r bold">
                                                                #{row.accountInfo?.username}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="text-h1">
                                                    https://status.aooz.in/{row.accountInfo?.username}   </div>
                                            </div>
                                        </div>

                                        <div className="p-0 ">
                                            <table className="table-fixed">
                                                <tbody>
                                                    <tr>

                                                        <td>
                                                            <div className="text-h3">
                                                                <b>{row.read + row.copy + row.like || 0}</b> Read
                                                            </div>
                                                        </td>

                                                        <td>
                                                         <div onClick={()=>navigate("/"+data.contentid)} className="text-h3 cursor">
                                                                <b>{row.comment || 0}</b> Comt
                                                            </div>  
                                                        </td>

                                                        <td>
                                                            {/* <IoColorPaletteOutline className="icon" /> */}
                                                        </td>
                                                        <td>
                                                            <CopyUID
                                                                id={
                                                                    row.message +
                                                                    "\n" +
                                                                    row.statusmoodEmoji + " #" + row.statusmood + " #aoozstatus #" + row.accountInfo?.username +
                                                                    "\nhttps://status.aooz.in/" + row.accountInfo?.username
                                                                }
                                                                contentid={row.contentid}
                                                            />
                                                        </td>

                                                        <td>

                                                            <GoDownload
                                                                onClick={() => {
                                                                    setDownloadingId(row);
                                                                    setdownpopup(true)
                                                                }
                                                                }
                                                                className="icon cursor"
                                                            />
                                                            {/* {
                                                                downloadingId === row.contentid
                                                                    ? <MdDownloadDone className="icon green" />
                                                                    : <GoDownload
                                                                        onClick={() =>
                                                                            downloadDivAsImage(
                                                                                row.contentid,
                                                                                "Aooz.in_" + row.statusmood + "_" + row.contentid
                                                                            )
                                                                        }
                                                                        className="icon cursor"
                                                                    />
                                                            } */}
                                                        </td>

                                                        <td>
                                                            <GoHeart onClick={() => Update_status_message_qry(row.contentid, "like")} className="icon cursor" />
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>

                                ))

                            ) : (
                                <p>No status found</p>
                            )}

                        </div>
                    </div>
                </div>
            </div>
            <Download_popup row={downloadingId}
                isOpen={downpopup}
                onClose={() => setdownpopup(false)}
            />
        </>
    );
}